function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "search_svg__a",
  d: "M7.61 15.22a7.61 7.61 0 117.61-7.61 7.61 7.61 0 01-7.61 7.61zM7.61 1a6.6 6.6 0 106.6 6.6A6.61 6.61 0 007.61 1zM13.488 14.211l.714-.714 5.792 5.792-.714.714z"
});

function SvgSearch(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/search.7fcae7bb.svg";
export { SvgSearch as ReactComponent };